import React, { Component } from 'react';
import styled from 'styled-components';
import Placeholder from '../../components/molecule/Placeholder';
import * as Constants from '../../core/constants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getMeetTrainerRequestLibrary, isLibraryLoading, libraryLoaded, meetTrainerRequestQuery, meetTrainerRequestBase } from '../../modules/IndividualCoach';
import searchController from '../../components/hoc/searchController'; 
import SearchBar from '../../components/organism/SearchBar';
import { getResources } from '../../modules/Resource';
import { createSelects, createSelect } from '../../utils';
import { toast } from 'react-toastify';
import DynamicTable from '../../components/molecule/Table';
import * as _ from 'lodash';
import { CircularProgress } from '@material-ui/core';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // height: 100%;
`
const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 115px;
`

const PlaceholderStyled = styled(Placeholder)`
  margin: 100px auto;
`
const StyledCircularProgress = styled(CircularProgress)`
  margin: 100px auto;
`

const IndividualCoachSearch = searchController(SearchBar, 'meettrainer', { params: { page_size: Constants.PER_PAGE_DEFAULT } });

class IndividualCoachLibrary extends Component {
  constructor(props) {
    super(props);
    this.selects = [];
    this.state = {
      page: Constants.START_PAGE_DEFAULT,
      perPage: Constants.PER_PAGE_DEFAULT,
      gotoNext: false,
    };
  }

  async componentDidMount() {
    const { getResources, resourceState, getMeetTrainerRequestLibrary, meetTrainerRequestBase } = this.props;
    const { page, perPage } = this.state;

    const initialSelect = createSelect('Status', 'Choose a status', 'q', [
      {
        label: 'new',
        value: 'new'
      },
      {
        label: 'assigned',
        value: 'assigned'
      },
    ], false);
    this.selects = [initialSelect];


    try {
      if(!resourceState.resourceData){
        await getResources();
      }

      meetTrainerRequestBase();
      await getMeetTrainerRequestLibrary({ params: { page, page_size: perPage } });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  onNext = () => {
    const { individualCoachState } = this.props;
    const { totalCount, meettrainer_requests } = individualCoachState;
    if (meettrainer_requests && totalCount && meettrainer_requests.length < totalCount && !individualCoachState.isLoading) {
      this.setState({gotoNext: true})
    }
  }

  libraryDidLoad = (results, count, query) => {
    this.props.libraryLoaded(results, count, query);
    this.setState({gotoNext: false});
  }

  startQuery = () => {
    const { meetTrainerRequestQuery, individualCoachState } = this.props;
    if (!individualCoachState.isLoading) {
      meetTrainerRequestQuery();
    }
  }

  extractColumns = (data, columns) => {
    return data?.map(row =>
      columns.reduce((obj, column) => {
        obj[column] = _.get(row, column);
        return obj;
      }, {})
    );
  };
    

  render() {
    const { resourceState, individualCoachState, isLibraryLoading, history, authState: {userData} } = this.props
    const { perPage, gotoNext } = this.state;
    const isAdmin = userData?.is_superuser;
    const columnKeys = ['id', 'user.name','user.email', 'created', 'status'];
    const columnNames = ['ID', 'Name', 'Email', 'Request Date', 'Status'];
    const dataWithDesiredColumns = this.extractColumns(
      individualCoachState.meettrainer_requests,
      columnKeys
    );

    const includedSelects = {
      cat: false,
      mg: false,
      il: false,
      eq: false,
      fg: false,
      tr: isAdmin,
    };

    return (
      <Container>
        <IndividualCoachSearch
          selects={createSelects(resourceState.resourceData, this.selects, includedSelects)}
          getter={isLibraryLoading}
          setter={this.libraryDidLoad}
          base={this.startQuery}
          gotoNext={gotoNext}
          perPage={perPage}
        />
        
        <Scrollable>
          {
            (
              individualCoachState.meettrainer_requests?.length <= 0 &&
              !individualCoachState.isLoading &&
              !resourceState.isLoading 
            ) ? (
              <PlaceholderStyled
                title="No Requests found"
                onClick={() => history.push('/digital-coaching/individual-coaching/')}
                buttonIcon='subdirectory_arrow_right'
              />
            ) : (
              individualCoachState.isLoading || resourceState.isLoading ? <StyledCircularProgress variant="indeterminate" size={35} thickness={4} color="secondary" /> :
                <DynamicTable
                  data={dataWithDesiredColumns}
                  columnKeys={columnKeys}
                  columnNames={columnNames}
                  items={individualCoachState.meettrainer_requests}
                />
            )
          }
        </Scrollable>
      </Container>
    )
  }
}

IndividualCoachLibrary.propTypes = {
};

IndividualCoachLibrary.defaultProps = {
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    resourceState: state.resourceState,
    individualCoachState: state.individualCoachState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    getMeetTrainerRequestLibrary: getMeetTrainerRequestLibrary,
    isLibraryLoading: isLibraryLoading,
    libraryLoaded: libraryLoaded,
    meetTrainerRequestQuery: meetTrainerRequestQuery,
    meetTrainerRequestBase: meetTrainerRequestBase,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(IndividualCoachLibrary);
